import { Button, Flex, Modal } from "antd";

import React from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteCouponCodeByIdAction } from "../../../../../../redux/services/coupon-codes/couponCodesServices";
import { CustomTitle } from "../../../../../common/customTitle";

const CouponCodeDeleteDialog = ({ open, onClose }) => {

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false)
  /* loading dependencies */

  /* id dependencies */
  const { selectedCouponCodeId } = useSelector((state) => state.couponCodes);
  /* id dependencies */

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedCouponCodeId ||
      selectedCouponCodeId === "" ||
      selectedCouponCodeId === null ||
      selectedCouponCodeId === undefined
    ) {
      onClose();
    }
  }, [selectedCouponCodeId]);
  /* initial dependencies */

  /* perform delete action */
  const handleDelete = () => {
    if (
        selectedCouponCodeId &&
        selectedCouponCodeId !== "" &&
        selectedCouponCodeId !== null &&
        selectedCouponCodeId !== undefined
    ) {
      const dataToBeSent = {
        selectedCouponCodeId,
      };
      dispatch(
        deleteCouponCodeByIdAction(dataToBeSent, navigate, setLoading)
      ).then(() => {
        onClose();
      });
    }
  };
  /* perform delete action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
      <CustomTitle textDecoration="underline" justifyContent="center">
        Delete
      </CustomTitle>
      <Title level={2}>Are you sure you want to Delete?</Title>
      <Flex gap="1rem" align="center" justify="center">
      <Button type="primary" onClick={handleDelete}>Yes</Button>
      <Button type="default" onClick={onClose}>No</Button>
      </Flex>
      </Flex>
    </Modal>
  );
};

export default CouponCodeDeleteDialog;
